import React from "react";
// import Objetivo from "./Objetivo";

function getPuntajeTri(props) {
  var puntaje = 0;
  var cantidad = 0;
  
  var types = ["Trivia", "Supervisor-Trivia"];
  
  if (props.points && props.points.length) {
    var aux1 = props.points.map(point => {return (types.indexOf(point.type) >= 0 ? point.amount : 0)});
    for (var i = 0; i < aux1.length; i++) {
      puntaje += aux1[i];
    }
    cantidad = aux1.length;
  }
  return {'puntaje': puntaje, 'cantidad': cantidad};
}

const Render = (props, context) => {
  var result = getPuntajeTri(props);
  
  return (
    <div className="col-md-6 mt-30">
      <h4>Trivias</h4>
      <div className="">
        <p>Trivias resueltas: <span className="avenirL">{result.cantidad}</span></p>
        <p>Puntos ganados:  <span className="avenirL">{result.puntaje}</span></p>
      </div>
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/PuntajeTrivias.js